import moment from 'moment';
import * as React from "react";
import { callApi } from "../../utils/api";
import { isEmpty } from "lodash";
import { ToastsStore } from 'react-toasts';
import { HintAudio } from './Hint/HintAudio';
import dayjs from "dayjs";
import TitleDeedInfo from './TitleDeedInfo';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

interface AllProps {
    id: number;
    path: string;
    onHintSaved?: () => void;
    onAudioSaved?: () => void;
}

export default class HintAboutFile extends React.Component<AllProps> {
    state = {
        hints: [] as any[],
        userHintAboutFile: '',
        deedinfo: [],
        loan_amount: "",
        contact_number: "",
        type_loan: "",
        appid: "",
        borrowername: "",
        bank_name: "",
        login_time: "",
        coApplicant: "",
        audioList: [] as any[],
    };

    componentDidMount() {
        this.getHints();
        this.getdeedInfo();
        this.getAudioList();
        window.addEventListener("query-hint-updated", this.onQueryHintUpdated);
    }

    componentWillUnmount() {
        window.removeEventListener("query-hint-updated", this.onQueryHintUpdated);
    }

    /** Refetch file hints when a related screen saves a per-query hint (e.g. ReceivedQueryMailDetails). */
    onQueryHintUpdated = () => {
        this.getHints();
    };

    getHints = () => {
        callApi("POST", "hint_get.php", { id: this.props.id })
            .then(res => res.data)
            .then(result => {
                this.setState({ hints: result.data });
            })
            .catch(err => {
                console.log(err);
            });
    }

    getAudioList = () => {
        callApi("POST", "hintaudio_get.php", { file_id: this.props.id })
            .then(res => res.data)
            .then(result => {
                this.setState({ audioList: result.audioList });
                // Call callback if audio list was fetched
                if (this.props.onAudioSaved) {
                    this.props.onAudioSaved();
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    getdeedInfo = () => {
        callApi("POST", "get_title_deed_info.php", { id: this.props.id })
            .then(res => res.data)
            .then(result => {
                this.setState({ deedinfo: result.data, loan_amount: result.loan_amount, contact_number: result.contact_number, type_loan: result.type_loan, borrowername: result.borrowername, appid: result.appid, coApplicant: result?.coApplicant, bank_name: result?.bank_name, login_time: result?.login_time });
            })
            .catch(err => {
                console.log(err);
            });
    }

    handleEditorChange = (content: string) => {
        const cleaned = content
            // Remove all inline style attributes
            .replace(/\s*style="[^"]*"/gi, "")
            // Remove all inline style with single quotes
            .replace(/\s*style='[^']*'/gi, "")
            // Remove box-sizing and other junk attributes
            .replace(/\s*(class|id|data-[^=]*)="[^"]*"/gi, "")
            // Collapse multiple <br> tags
            .replace(/(<br\s*\/?>){2,}/gi, "<br>")
            // Remove leading empty paragraphs (including those with <br> that might not be properly closed)
            .replace(/^(<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>)*/gi, "")
            .replace(/^(<p>(\s|&nbsp;|<br\s*\/?>)*)/gi, "") // Also catch opening <p> without closing tag
            // Remove trailing empty paragraphs
            .replace(/(<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>)*$/gi, "")
            .replace(/(<br\s*\/?>)*<\/p>$/gi, "</p>") // Clean up trailing <br> before closing </p>
            // Remove empty spans
            .replace(/<span[^>]*>\s*<\/span>/gi, "")
            // Remove zero-width spaces
            .replace(/​/g, "")
            .trim();

        this.setState({ userHintAboutFile: cleaned });
    }

    saveHint = () => {
        // Strip all HTML tags and decode &nbsp; to check actual text content
        const plainText = this.state.userHintAboutFile
            .replace(/<[^>]*>/g, "")       // strip HTML tags
            .replace(/&nbsp;/g, " ")        // decode &nbsp;
            .replace(/​/g, "")       // remove zero-width spaces
            .replace(/\u200B/g, "")         // remove zero-width space (unicode)
            .trim();

        if (isEmpty(plainText) || /^[\s-]/.test(plainText)) {
            ToastsStore.error("Hint cannot be empty");
            return;
        }
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        callApi('POST', 'add_hints.php', { id: this.props.id, userid: userId, hints: this.state.userHintAboutFile })
            .then(res => res.data)
            .then(result => {
                this.setState({ userHintAboutFile: '' });
                ToastsStore.success("Hint added successfully");
                this.getHints();
                if (this.props.onHintSaved) {
                    this.props.onHintSaved();
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    handleAudioSaved = () => {
        // Refresh audio list and call callback
        this.getAudioList();
        if (this.props.onAudioSaved) {
            this.props.onAudioSaved();
        }
    }

    getHintHtml = (hints: any) => {
        if (typeof hints !== "string") return "";
        // Preserve text line breaks for plain-text hints while keeping existing HTML markup support.
        return hints.replace(/\r\n|\r|\n/g, "<br />");
    }

    render() {
        // Combine hints and audioList, then sort by created_date in ascending order
        const combinedData = [
            ...(this.state.hints ?? []).map((hint: any) => ({ ...hint, type: "hint" })),
            ...(this.state.audioList ?? []).map((audio: any) => ({ ...audio, type: "audio" })),
        ].sort((a, b) => moment(a.created_date).diff(moment(b.created_date)));

        return (
            <>
                <div className="row" style={{ height: (this.props.path == "index" || this.props.path == "querymaildetails") ? "auto" : "500px" }}>
                    <div className={`col-md-${(this.props.path == "index" || this.props.path == "querymaildetails") ? '7' : '5'}`}>
                        <div className="card latest-update-card">
                            <div className="card-header">
                                <h5>Hints About Files</h5>
                            </div>
                            <div className="" style={{ height: this.props.path == "index" ? '41vh' : (this.props.path == 'querymaildetails' ? '29vh' : '64vh'), position: 'relative', overflow: 'auto' }}>
                                <div className="card-body">
                                    <div className="latest-update-box">
                                        {combinedData.length > 0 && combinedData.map((item: any, index: number) => (
                                            <div className={index === 0 ? "row p-t-20 p-b-20" : "row p-b-20"} key={index}>
                                                <div className="col-auto text-right update-meta">
                                                    <i className="b-primary update-icon ring"></i>
                                                </div>
                                                <div className="col p-l-5">
                                                    <h6 className="m-0 bold">{item.created_by} | <span style={{ color: '#129b12' }}>{item.designation}</span> <span style={{ fontSize: '12px' }}>{item.created_date ? `(${dayjs(item.created_date).format("DD-MM-YYYY HH:mm:ss")})` : ""}</span></h6>
                                                    <p className="m-b-0 hint-content" style={{ wordBreak: 'break-word', lineHeight: '1.4' }} dangerouslySetInnerHTML={{ __html: this.getHintHtml(item.hints) }} />
                                                    {item.type === 'audio' && item.audio_base && (
                                                        <audio controls style={{ height: "40px", marginTop: '10px' }}>
                                                            <source src={item.audio_base} type="audio/webm; codecs=opus" />
                                                            Your browser does not support the audio element.
                                                        </audio>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="ps__rail-x" style={{ left: '0px', bottom: '0px' }}>
                                    <div className="ps__thumb-x" style={{ left: '0px', bottom: '0px' }}></div>
                                </div>
                                <div className="ps__rail-y" style={{ top: '0px', height: '320px', right: '0px' }}>
                                    <div className="ps__thumb-y" style={{ top: '0px', height: '212px' }}></div>
                                </div>
                            </div>
                            {(this.props.path == "index" || this.props.path == "querymaildetails") && <>
                                <div className="col-md-12">
                                    <div className="form-group" style={{ marginTop: "20px" }}>
                                        <label>Add Hints</label>
                                        <SunEditor
                                            setContents={this.state.userHintAboutFile}
                                            onChange={this.handleEditorChange}
                                            onPaste={(e, cleanData, maxCharCount) => {
                                                // Let handleEditorChange handle the cleanup via onChange
                                                return true;
                                            }}
                                            onKeyDown={(e) => {
                                                // Prevent any formatting shortcuts except Ctrl+B
                                                if ((e.ctrlKey || e.metaKey)) {
                                                    const key = e.key.toLowerCase();
                                                    // Allow only basic editing shortcuts
                                                    const allowedKeys = ['b', 'x', 'c', 'v', 'a', 'z', 'y'];
                                                    if (!allowedKeys.includes(key)) {
                                                        e.preventDefault();
                                                        return false;
                                                    }
                                                }
                                                return true;
                                            }}
                                            setOptions={{
                                                height: this.props.path == 'querymaildetails' ? '12vh' : '25vh',
                                                defaultStyle: 'line-height: 1.15; font-size: 12px;',
                                                pasteTagsWhitelist: 'p|br|strong|em|u|s|ul|ol|li', // only allow clean tags on paste
                                                buttonList: [
                                                    ['bold'],
                                                ],
                                            }}
                                        />
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <button onClick={this.saveHint} className="btn btn-rounded btn-success">
                                            Save
                                        </button>
                                        <HintAudio
                                            fileId={this.props.id}
                                            refetchAudioList={this.handleAudioSaved}
                                            page={'hint'}
                                        />
                                    </div>
                                </div>
                            </>}
                        </div>
                    </div>
                    <div className={`col-md-${(this.props.path == "index" || this.props.path == "querymaildetails") ? '5' : '7'}`}>
                        <TitleDeedInfo
                            path={this.props.path}
                            type_loan={this.state.type_loan}
                            appid={this.state.appid}
                            borrowername={this.state.borrowername}
                            bank_name={this.state.bank_name}
                            login_time={this.state.login_time}
                            loan_amount={this.state.loan_amount}
                            contact_number={this.state.contact_number}
                            coApplicant={this.state.coApplicant}
                            deedinfo={this.state.deedinfo}
                        />
                    </div>
                </div>
            </>
        );
    }
}